import $ from 'jquery';

$( '.interactive-accordion-item' ).on('click', function(e) {
  e.preventDefault();

  const $this = $(this);
  const interactiveList = $this.closest('.interactive-accordion');
  let interactiveContent = $('.interactive-content').children().get( $this.index() );

  interactiveList.find('.interactive-accordion-item.active').removeClass('active');
  $this.addClass('active');
  
  $(interactiveContent).parent().children().addClass('hidden');
  $(interactiveContent).removeClass('hidden');
})

